import { ProductList } from '../components/catalog/ProductList';
import { useProducts } from '../hooks/useProducts';
import { useFavorites } from '../providers';

export function FavoritesPage() {
  const { data: products = [], isLoading, isError } = useProducts();
  const favorites = useFavorites();

  if (isLoading) return <p className="section-pad mono-label">ЗАВАНТАЖЕННЯ…</p>;
  if (isError) return <p className="section-pad mono-label">Не вдалося завантажити улюблене.</p>;

  return (
    <ProductList
      products={products.filter((product) => favorites.has(product.id))}
      title="Улюблене"
      counterLabel="ЗБЕРЕЖЕНО"
      emptyText="Ви ще нічого не зберегли. Натисніть ♡ біля сорту."
    />
  );
}
